<template>
  <div>
    <div v-if="loading">
      Loading ...
    </div>

    <div
      v-if="user && !loading"
      class="customer-view">
      <div class="user-info">
        <table class="table table-user-info">
          <thead>
            <tr>
              <th
                colspan="4"
                class="text-center"
              >
                <h3>User Information</h3>
              </th>
            </tr>
          </thead>
          <tr>
            <th>ID</th>
            <td>{{ user.id }}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{ user.name }}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{ user.email }}</td>
          </tr>
        </table>

        <!-- <licence-table></licence-table> -->
        <!-- v-if="licences.length !== 0" -->
        <div >
          <table class="table table-user-licenses-list mt-4 table-bordered">
            <thead>
              <tr>
                <th
                  colspan="6"
                  class="text-center"
                >
                  <h3>List of licenses</h3>
                </th>
              </tr>
            </thead>
            <tr class="table-second-header">
              <!-- <th scope="col">#</th> -->
              <th scope="col">License Name</th>
              <th scope="col">Creation date</th>
              <th scope="col">Expiration date</th>
              <th scope="col">Mac address</th>
              <th scope="col">Harddisk serial number</th>
              <th scope="col">Download</th>
            </tr>
            <tbody>
              <tr
                v-for="licence in licences"
                :key="licence.id">
                <!-- <th scope="row">{{licence.id}}</th> -->
                <td>{{ licence.licence_name.slice(0, -18)+'.zip' }}</td>
                <td>{{ licence.created_at }}</td>
                <td>{{ licence.expiration_date }}</td>
                <td>{{ licence.mac_address }}</td>
                <td>{{ licence.hdd }}</td>
                <td>
                  <a
                    class="table-link"
                    @click="downloadUserLicence(licence.qaccess,licence.licence_name)">
                    <font-awesome-icon
                      size="2x"
                      icon="download"
                      class="mr-2"/>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <request-list
          v-if="license_requests.length > 0"
          :user_id="this.$route.params.id"/>

        <router-link
          to="/users"
          class="btn btn-dark">
          <font-awesome-icon
            size="1x"
            icon="arrow-left"
            class="mr-2"/>Back to the user list
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>

import RequestList from './../profile/currentUser/pages/RequestList.vue'
import { vp } from '@/tools/helpers'

export default {
  components: {
    RequestList
  },
  data () {
    return {
      licences: [],
      loading: false,
      license_requests: [],

      user: {
        id: null,
        name: null,
        email: null
      }
    }
  },
  mounted () {
    this.fetchUser()
  },
  methods: {
    async fetchUser () {
      this.loading = true
      let userData = await this.$get('users/show_user/' + this.$route.params.id)
      this.user = userData.data
      this.licences = userData.data.licences
      this.license_requests = userData.data.licrequests
      this.loading = false
    },

    // async downloadUserLicence(qaccess) {
    //   const response = await this.$get("users/get_user_licence/"+qaccess, {responseType: 'arraybuffer'} );
    //   //console.log(response)
    //   //const { data, status, statusText, headers } = await this.$get("users/"+this.$route.params.id)
    //   let blob = new Blob([response.data]);
    //   let link = document.createElement("a");
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = "license.zip";
    //   link.click();
    // },

    downloadUserLicence (qaccess, name) {
      // {responseType: 'arraybuffer'}
      this.$forlic.get_user_licence(qaccess
      ).then(response => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = name
        link.click()
      }).catch(error => {
        // console.log(error.message)
        vp.$notify.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
.user-img {
  flex: 1;
}
.user-img img {
  max-width: 160px;
}
.user-info {
  flex: 3;
}
.table-user-licenses-list thead th {
  background-color: rgb(254, 255, 246);
}

</style>
